export default __webpack_public_path__ + "static/media/mobileman.63260b42.png";